// modules/PlanLegend.js
import React                from 'react';
// import StatusSquare		    from '../../images/StatusSquare';
// import StatusCircle		    from '../../images/StatusCircle';
import StatusSquare		    from '../../images/StatusSquare';
// import StatusBorderedDot	from '../../images/StatusBorderedDot';

class PlanLegend extends React.Component {
	render() {
		return (
			<div className="stage-legend">
				<div className="status-div status-hold">Builders Exclusive &nbsp;<StatusSquare/></div>
				<div className="status-div status-sold">Sold &nbsp;<StatusSquare/></div>
			</div>
		);
	}
}

export default PlanLegend;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanLegend.js
 **/